// Generated by Melange

import * as Buhta_payrollapis__Buhta_payroll_hrm_v1_employment_type from "./buhta_payroll_hrm_v1_employment_type.js";
import * as Buhta_taxapis__Buhta_tax_control_v1alpha1_person_category_benefit from "../../taxapis/gen/buhta_tax_control_v1alpha1_person_category_benefit.js";
import * as Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_deduction_benefit from "../../taxapis/gen/buhta_tax_control_v1alpha1_tax_deduction_benefit.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_info.ml",
  92,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [[
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "EmploymentInfo"
                      ]]
                  },
                  "V1alpha1"
                ]]
            },
            "Hrm"
          ]]
      },
      "Payroll"
    ]]
});

const Payroll = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_info.ml",
  143,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "EmploymentInfo"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "Hrm"
    ]]
});

const Hrm = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_info.ml",
  192,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "EmploymentInfo"
          ]]
      },
      "V1alpha1"
    ]]
});

const V1alpha1 = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_info.ml",
  239,
  12
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "EmploymentInfo"
    ]]
});

const EmploymentInfo = Caml_module.init_mod([
  "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employment_info.ml",
  284,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.payroll.hrm.v1alpha1.EmploymentInfo";
}

function make(residentOpt, eaeu_residentOpt, has_residence_permitOpt, employment_typeOpt, positionOpt, tax_deduction_benefitsOpt, category_benefitsOpt, salary_rate, mzp_salaryOpt, effective_salary_rate, gross_methodOpt, param) {
  const resident = residentOpt !== undefined ? residentOpt : false;
  const eaeu_resident = eaeu_residentOpt !== undefined ? eaeu_residentOpt : false;
  const has_residence_permit = has_residence_permitOpt !== undefined ? has_residence_permitOpt : false;
  const employment_type = employment_typeOpt !== undefined ? employment_typeOpt : Curry._1(Buhta_payrollapis__Buhta_payroll_hrm_v1_employment_type.Buhta.Payroll.Hrm.V1.EmploymentType.from_int_exn, 0);
  const position = positionOpt !== undefined ? positionOpt : "";
  const tax_deduction_benefits = tax_deduction_benefitsOpt !== undefined ? tax_deduction_benefitsOpt : /* [] */ 0;
  const category_benefits = category_benefitsOpt !== undefined ? category_benefitsOpt : /* [] */ 0;
  const mzp_salary = mzp_salaryOpt !== undefined ? mzp_salaryOpt : false;
  const gross_method = gross_methodOpt !== undefined ? gross_methodOpt : false;
  return {
    resident: resident,
    eaeu_resident: eaeu_resident,
    has_residence_permit: has_residence_permit,
    employment_type: employment_type,
    position: position,
    tax_deduction_benefits: tax_deduction_benefits,
    category_benefits: category_benefits,
    salary_rate: salary_rate,
    mzp_salary: mzp_salary,
    effective_salary_rate: effective_salary_rate,
    gross_method: gross_method
  };
}

const merge_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "resident",
    "resident"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_eaeu_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "eaeu_resident",
    "eaeuResident"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_has_residence_permit = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    6,
    "has_residence_permit",
    "hasResidencePermit"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_employment_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    12,
    "employment_type",
    "employmentType"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_payrollapis__Buhta_payroll_hrm_v1_employment_type.Buhta.Payroll.Hrm.V1.EmploymentType),
  Curry._1(Buhta_payrollapis__Buhta_payroll_hrm_v1_employment_type.Buhta.Payroll.Hrm.V1.EmploymentType.from_int_exn, 0)
]));

const merge_position = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    13,
    "position",
    "position"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let = Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_deduction_benefit.Buhta.Tax.Control.V1alpha1.TaxDeductionBenefit;

const merge_tax_deduction_benefits = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    14,
    "tax_deduction_benefits",
    "taxDeductionBenefits"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

const $$let$1 = Buhta_taxapis__Buhta_tax_control_v1alpha1_person_category_benefit.Buhta.Tax.Control.V1alpha1.PersonCategoryBenefit;

const merge_category_benefits = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    15,
    "category_benefits",
    "categoryBenefits"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

const merge_salary_rate = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    21,
    "salary_rate",
    "salaryRate"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_mzp_salary = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    22,
    "mzp_salary",
    "mzpSalary"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_effective_salary_rate = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    23,
    "effective_salary_rate",
    "effectiveSalaryRate"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_gross_method = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    24,
    "gross_method",
    "grossMethod"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

function merge(t1, t2) {
  return {
    resident: Curry._2(merge_resident, t1.resident, t2.resident),
    eaeu_resident: Curry._2(merge_eaeu_resident, t1.eaeu_resident, t2.eaeu_resident),
    has_residence_permit: Curry._2(merge_has_residence_permit, t1.has_residence_permit, t2.has_residence_permit),
    employment_type: Curry._2(merge_employment_type, t1.employment_type, t2.employment_type),
    position: Curry._2(merge_position, t1.position, t2.position),
    tax_deduction_benefits: Curry._2(merge_tax_deduction_benefits, t1.tax_deduction_benefits, t2.tax_deduction_benefits),
    category_benefits: Curry._2(merge_category_benefits, t1.category_benefits, t2.category_benefits),
    salary_rate: Curry._2(merge_salary_rate, t1.salary_rate, t2.salary_rate),
    mzp_salary: Curry._2(merge_mzp_salary, t1.mzp_salary, t2.mzp_salary),
    effective_salary_rate: Curry._2(merge_effective_salary_rate, t1.effective_salary_rate, t2.effective_salary_rate),
    gross_method: Curry._2(merge_gross_method, t1.gross_method, t2.gross_method)
  };
}

function spec(param) {
  const $$let = Buhta_taxapis__Buhta_tax_control_v1alpha1_tax_deduction_benefit.Buhta.Tax.Control.V1alpha1.TaxDeductionBenefit;
  const $$let$1 = Buhta_taxapis__Buhta_tax_control_v1alpha1_person_category_benefit.Buhta.Tax.Control.V1alpha1.PersonCategoryBenefit;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "resident",
      "resident"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "eaeu_resident",
      "eaeuResident"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      6,
      "has_residence_permit",
      "hasResidencePermit"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      12,
      "employment_type",
      "employmentType"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_payrollapis__Buhta_payroll_hrm_v1_employment_type.Buhta.Payroll.Hrm.V1.EmploymentType),
    Curry._1(Buhta_payrollapis__Buhta_payroll_hrm_v1_employment_type.Buhta.Payroll.Hrm.V1.EmploymentType.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      13,
      "position",
      "position"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      14,
      "tax_deduction_benefits",
      "taxDeductionBenefits"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      15,
      "category_benefits",
      "categoryBenefits"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$1.name,
      make: $$let$1.make,
      from_proto: $$let$1.from_proto,
      from_proto_exn: $$let$1.from_proto_exn,
      to_proto: $$let$1.to_proto,
      to_proto$p: $$let$1.to_proto$p,
      merge: $$let$1.merge,
      to_json: $$let$1.to_json,
      from_json_exn: $$let$1.from_json_exn,
      from_json: $$let$1.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      21,
      "salary_rate",
      "salaryRate"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      22,
      "mzp_salary",
      "mzpSalary"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      23,
      "effective_salary_rate",
      "effectiveSalaryRate"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      24,
      "gross_method",
      "grossMethod"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.nil)))))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry.app(serialize, [
    writer,
    param.resident,
    param.eaeu_resident,
    param.has_residence_permit,
    param.employment_type,
    param.position,
    param.tax_deduction_benefits,
    param.category_benefits,
    param.salary_rate,
    param.mzp_salary,
    param.effective_salary_rate,
    param.gross_method
  ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(resident, eaeu_resident, has_residence_permit, employment_type, position, tax_deduction_benefits, category_benefits, salary_rate, mzp_salary, effective_salary_rate, gross_method) {
  return {
    resident: resident,
    eaeu_resident: eaeu_resident,
    has_residence_permit: has_residence_permit,
    employment_type: employment_type,
    position: position,
    tax_deduction_benefits: tax_deduction_benefits,
    category_benefits: category_benefits,
    salary_rate: salary_rate,
    mzp_salary: mzp_salary,
    effective_salary_rate: effective_salary_rate,
    gross_method: gross_method
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.EmploymentInfo", spec(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
      param.resident,
      param.eaeu_resident,
      param.has_residence_permit,
      param.employment_type,
      param.position,
      param.tax_deduction_benefits,
      param.category_benefits,
      param.salary_rate,
      param.mzp_salary,
      param.effective_salary_rate,
      param.gross_method
    ]);
  };
}

function constructor$1(resident, eaeu_resident, has_residence_permit, employment_type, position, tax_deduction_benefits, category_benefits, salary_rate, mzp_salary, effective_salary_rate, gross_method) {
  return {
    resident: resident,
    eaeu_resident: eaeu_resident,
    has_residence_permit: has_residence_permit,
    employment_type: employment_type,
    position: position,
    tax_deduction_benefits: tax_deduction_benefits,
    category_benefits: category_benefits,
    salary_rate: salary_rate,
    mzp_salary: mzp_salary,
    effective_salary_rate: effective_salary_rate,
    gross_method: gross_method
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.EmploymentInfo", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, EmploymentInfo, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "EmploymentInfo"
    ]]
}, V1alpha1, {
  EmploymentInfo: EmploymentInfo
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "EmploymentInfo"
          ]]
      },
      "V1alpha1"
    ]]
}, Hrm, {
  V1alpha1: V1alpha1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "EmploymentInfo"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "Hrm"
    ]]
}, Payroll, {
  Hrm: Hrm
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [[
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "EmploymentInfo"
                      ]]
                  },
                  "V1alpha1"
                ]]
            },
            "Hrm"
          ]]
      },
      "Payroll"
    ]]
}, Buhta, {
  Payroll: Payroll
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
